import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {QueryClient, QueryClientProvider} from "@tanstack/react-query";
import ModalProvider from "./utils/modal/ModalProvider";
import ModalContainer from "./utils/modal/ModalContainer";
import AuthProvider from "./utils/contextapi/AuthProvider";
import TableProvider from "./utils/contextapi/TableProvider";
import { ServiceProvider } from './utils/contextapi/ServiceProvider';


const queryClient = new QueryClient();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <QueryClientProvider client={queryClient}>
        <AuthProvider>
            <ServiceProvider>
                <ModalProvider>
                    <TableProvider>
                        <ModalContainer />
                        <App />
                    </TableProvider>
                </ModalProvider>
            </ServiceProvider>
        </AuthProvider>
    </QueryClientProvider>
);

reportWebVitals();
